import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngxs/store";
import { Subject } from "rxjs";
import { GlobalConfigurationState } from "../../state/global-configuration.state";
import { BroadcastService } from "@cv-invision/core";
import { SCOPE_ORDER_UPDATE_DOCUMENTS } from "../model/product-constant";

@Component({
	selector: 'cv-invision-scope-order-documents',
	templateUrl: './scope-order-documents.component.html',
	styleUrls: ['./scope-order-documents.component.scss'],
})
export class ScopeOrderDocumentsComponent implements OnDestroy {
	private atComponentDestroy = new Subject();
	@Input() viewMode: boolean = false;
	@Input() documents: any;

	public sourceList: Array<string> = [
		'Appscope',
		'Acuity',
		'Class',
		'cmpacuity'
	];

	public appAscopeList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeDocumentTypes);
	public acuityList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getAcuityDocumentTypes);
	public cmpAcuityList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityDocumentTypes);
	public classList: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getClassValuationDocTypes);

	/*public classList: Array<string> = [
		'PDR',
		'PFR'
	];*/

	constructor(
		private store: Store,
		private broadcastService: BroadcastService
	) {
    }

	onDeleteDocument(documentIndex: number): void {
		this.documents = this.documents.filter((document: any, index: number) => {
			return index !== documentIndex;
		});

		this.onUpdateDocuments()
	}

	onAddDocument(): void {
		this.documents.push({
			documentSource: 'Appscope',
			documentType: null,
			isFinalDocument: false
		});

		this.onUpdateDocuments();
	}

	getDocumentTypeValue(source: string, value: string): Array<any> {
		let selectedValue: Array<any> = [];
		switch (source.toLowerCase()) {
			case 'appscope':
				selectedValue = this.appAscopeList.filter((appAscope) => appAscope.id === value);
				break;
			case 'acuity':
				selectedValue = this.acuityList.filter((acuity) => acuity.id === value);
				break;
			case 'cmpacuity':
				selectedValue = this.cmpAcuityList.filter((acuity) => acuity.id === value);
				break;
			case 'class':
				selectedValue = this.classList.filter((classElement) => classElement.id === value);
				break;
		}

		return selectedValue;
	}

	onDocumentSourceSelected(documentSource: string, documentIndex: number): void {
		const document                = this.documents[documentIndex];
		document.documentSource       = documentSource;
		this.documents[documentIndex] = document;
		this.onUpdateDocuments();
	}

	onDocumentTypeSelected(source: string, documentType: any, documentIndex: number): void {
		const document = this.documents[documentIndex];
		/*switch (source) {
			case 'appscope':
			case 'acuity':
			case 'cmpacuity':
				document.documentType = documentType[0] ? documentType[0].id : null;
				break;
			case 'class':
				document.documentType = documentType;
				break;
		}*/

		document.documentType = documentType[0] ? documentType[0].id : null;

		this.documents[documentIndex] = document;

		this.onUpdateDocuments();
	}

	onFinalDocument(isFinalDocument: boolean, documentIndex: number): void {
		const document                = this.documents[documentIndex];
		document.isFinalDocument      = isFinalDocument;
		this.documents[documentIndex] = document;

		this.onUpdateDocuments();
	}

	onUpdateDocuments() {
		this.broadcastService.broadcast({
			name: SCOPE_ORDER_UPDATE_DOCUMENTS,
			event: {
				data: this.documents
			}
		});
	}

	ngOnDestroy(): void {
        this.atComponentDestroy.next({});
        this.atComponentDestroy.unsubscribe();
    }
}
